import Hero             from '../components/home/Hero';
import Stats            from '../components/home/Stats';
import Partners         from '../components/home/Partners';
import ServicesPreview  from '../components/home/ServicesPreview';
import WhyUs            from '../components/home/WhyUs';
import ProjectsShowcase from '../components/home/ProjectsShowcase';
import CTABanner        from '../components/home/CTABanner';
import usePageTitle     from '../hooks/usePageTitle';

const Home = () => {
  usePageTitle('');
  return (
    <div>
      <Hero />
      <Stats />
      <Partners />
      <ServicesPreview />
      <WhyUs />
      <ProjectsShowcase />
      <CTABanner />
    </div>
  );
};

export default Home;
